import {
  SIMULADOR_FINANCIERO_GET_LINEAS_SIMULACION_FINANCIACION_BEGIN,
  SIMULADOR_FINANCIERO_GET_LINEAS_SIMULACION_FINANCIACION_SUCCESS,
  SIMULADOR_FINANCIERO_GET_LINEAS_SIMULACION_FINANCIACION_FAILURE,
  SIMULADOR_FINANCIERO_GET_LINEAS_SIMULACION_FINANCIACION_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_SF } from '../../../common/config';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getLineasSimulacionFinanciacion({body = {}} = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SIMULADOR_FINANCIERO_GET_LINEAS_SIMULACION_FINANCIACION_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let doRequest = '';
      let bodyApi = {};
      if (body.byMontoTotal) {
        bodyApi = {
          "montoCuota" : body.value,
          "plazos" : body.plazo === 0 ? null : body.plazo
        }
        doRequest = axios.post(REACT_APP_API_SF + "/creditsByMontoPlazos", bodyApi);
      } else {
        bodyApi = {
          "cuotaProm" : body.value,
          "plazos" : body.plazo === 0 ? null : body.plazo
        }
        doRequest = axios.post(REACT_APP_API_SF + "/creditsByPlazos", bodyApi);
      }
      
      doRequest.then(
        (res) => {
          dispatch({
            type: SIMULADOR_FINANCIERO_GET_LINEAS_SIMULACION_FINANCIACION_SUCCESS,
            data: Array.isArray(res.data.data) ? res.data.data : [],
            byMontoTotal: body.byMontoTotal
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SIMULADOR_FINANCIERO_GET_LINEAS_SIMULACION_FINANCIACION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetLineasSimulacionFinanciacionError() {
  return {
    type: SIMULADOR_FINANCIERO_GET_LINEAS_SIMULACION_FINANCIACION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_GET_LINEAS_SIMULACION_FINANCIACION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getLineasSimulacionFinanciacionPending: true,
        getLineasSimulacionFinanciacionError: null,
      };

    case SIMULADOR_FINANCIERO_GET_LINEAS_SIMULACION_FINANCIACION_SUCCESS:
      // The request is success
      let simulacionFinanciacion = {...state.simulacionFinanciacion};
      action.data.forEach((credito) => {
        credito['showBtnElegir'] = false;
      });

      if (action.byMontoTotal) {
        simulacionFinanciacion.lineasPorMontoTotal = action.data;
      } else {
        simulacionFinanciacion.lineasPorCuotaMensual = action.data;
      }
      return {
        ...state,
        simulacionFinanciacion: simulacionFinanciacion,
        getLineasSimulacionFinanciacionPending: false,
        getLineasSimulacionFinanciacionError: null,
      };

    case SIMULADOR_FINANCIERO_GET_LINEAS_SIMULACION_FINANCIACION_FAILURE:
      // The request is failed
      return {
        ...state,
        getLineasSimulacionFinanciacionPending: false,
        getLineasSimulacionFinanciacionError: action.data.error,
      };

    case SIMULADOR_FINANCIERO_GET_LINEAS_SIMULACION_FINANCIACION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getLineasSimulacionFinanciacionError: null,
      };

    default:
      return state;
  }
}
